import PropTypes from 'prop-types';

const GigAssetPropType = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    attachment_id: PropTypes.string,
    type: PropTypes.oneOf(['ImageAsset', 'VideoAsset', 'AudioAsset']),
    cloud_img_main_gig: PropTypes.string,
});

const GigAttachmentPropType = PropTypes.shape({
    id: PropTypes.string, // GigAssetPropType['attachment_id']
    stream_url: PropTypes.string,
    image_url: PropTypes.string,
});

export const GigInfoPropType = PropTypes.shape({
    gig_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    category_id: PropTypes.number,
    sub_category_id: PropTypes.number,
    nested_sub_category_id: PropTypes.number,
    price_i: PropTypes.number,
    assets: PropTypes.arrayOf(GigAssetPropType),
    attachments: PropTypes.arrayOf(GigAttachmentPropType),
    cached_slug: PropTypes.string,
});
